<template>
  <div style="margin: 10px 0px">

    <span style="color: #909399;padding: 10px 0px">请求方法：</span>
    <el-radio @change='change' style="padding: 10px 0px" v-for="(item,index) in methods" v-bind:key="item.key" v-model="radio" :label="item.key">{{item.value}}</el-radio>
    <span class="error-method" v-show="showMethodsErrorCom">请选择请求方法</span>
  </div>
</template>

<script>

  export default {
    name: 'Methods',
    props:{
      showMethodsError:false
    },
    watch:{
      showMethodsError(val){
        this.showMethodsErrorCom=val
      }
    },
    methods:{
      change(val){
        this.$emit('change',val)
      },
      initMethods(){
        this.radio='AND_SHODE'

      }
    },
    mounted(){
      this.$emit('change',this.radio)
    },
    data () {
      let methods=[
        {key:'GET',value:'GET'},
        {key:"POST",value:'POST'},
        {key:"DELETE",value:'DELETE'},
        {key:"PUT",value:'PUT'},
        ]
      return {
        showMethodsErrorCom:this.showMethodsError,
        methods:methods,
        radio:'GET'
      }
    }
  }
</script>
<style scoped>
  .error-method{
    color: #f56c6c;
    font-size: 12px;
    line-height: 26px;
    padding-top: 4px;
    position: absolute;
    right: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/main/permission/components/MethodComponent.vue